import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import Signup from './views/Signup.vue';
import StepPassType from './views/StepPassType.vue';
import StepPayButton from './views/StepPayButton.vue';
import StepProfile from './views/StepProfile.vue';
import StepProfileWithoutAccount from './views/StepProfileWithoutAccount.vue';
import StepAddress from './views/StepAddress.vue';
import StepOrderComplete from './views/StepOrderComplete.vue';
import StepPayment from './views/StepPayment.vue';
import StepPhoneVerification from './views/StepPhoneVerification.vue';
import StepDiscountVerification from './views/StepDiscountVerification.vue';

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/discount',
      redirect() {
        return { name: 'pass', params: { discount: true } };
      },
    },
    {
      path: '/discount/promo/:promo?',
      redirect(to) {
        if (to.params.promo) {
          store.dispatch('updatePromotionCode', {
            displayCode: to.params.promo,
          });
        }
        return { name: 'pass', params: { discount: true } };
      },
    },
    {
      path: '/:pass(\\d+)?/promo/:promo?',
      redirect(to) {
        if (to.params.promo) {
          // TODO: replace with custom validation in store.js
          store.dispatch('updatePromotionCode', {
            displayCode: to.params.promo,
          });
        }
        if (to.params.pass) {
          const pass = parseInt(to.params.pass, 10);
          const passType = store.state.passTypes.find(type => type.id === pass);
          if (passType) {
            store.dispatch('updatePass', pass);
            return { name: store.getters.nextStep('pass') };
          }
        }
        return { name: 'pass' };
      },
    },
    {
      path: '/:pass(\\d+)?/discount/:code',
      redirect(to) {
        const pass = parseInt(to.params.pass, 10);
        const passType = store.state.passTypes.find(type => type.id === pass);

        if (passType) {
          store.dispatch('updatePass', pass);
          if (passType.discountVerification) {
            store.dispatch('updateRegistration', { enrollmentCode: to.params.code });
          }
          return { name: store.getters.nextStep('pass') };
        }

        return { name: 'pass' };
      },
    },
    {
      path: '/:pass(\\d+)',
      redirect(to) {
        const pass = parseInt(to.params.pass, 10);
        const passType = store.state.passTypes.find(type => type.id === pass);
        if (passType) {
          store.dispatch('updatePass', pass);
          return { name: store.getters.nextStep('pass') };
        }
        return { name: 'pass' };
      },
    },
    {
      path: '/',
      component: Signup,
      children: [
        {
          path: '',
          name: 'pass',
          component: StepPassType,
          props: true,
        },
        {
          path: 'phone',
          name: 'phoneVerification',
          component: StepPhoneVerification,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'verify',
          name: 'discountVerification',
          component: StepDiscountVerification,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'account',
          name: 'payButton',
          component: StepPayButton,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'profile',
          name: 'profileWithoutAccount',
          component: StepProfileWithoutAccount,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'full-profile',
          name: 'profile',
          component: StepProfile,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'address',
          name: 'address',
          component: StepAddress,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'payment',
          name: 'payment',
          component: StepPayment,
          meta: { requiresPassInCart: true },
        },
        {
          path: 'thanks',
          name: 'orderComplete',
          component: StepOrderComplete,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresPassInCart)) {
    // redirect back to pass selection if coming from a page that requires a pass in your cart
    const noPass = store.state.registration.planId === null;
    const orderComplete = store.state.order.complete === true;
    if (noPass || orderComplete) {
      next({ name: 'pass' });
    } else {
      next();
    }
    // require either a pass or an order, otherwise rediret back
  } else if (to.name === 'orderComplete' && !store.state.order.complete && store.state.registration.planId === null) {
    next({ name: 'pass' });
  } else {
    next();
  }
});

// send vue path to google analytics to allow tracking of signup page progress
router.afterEach((to) => {
  // get the http path, and add the vue path
  const fullPath = (window.location.pathname + to.path).replace('//', '/');
  if (typeof window.ga !== 'undefined') {
    window.ga('set', 'page', fullPath);
    window.ga('send', 'pageview');
  }
  // add ga4 event
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'page_view', {
      page_location: window.location.origin + fullPath,
      page_title: `signup - ${to.name}`,
    });
  }
});

export default router;
